import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import Button from "../../../../../../modules/commons/Button";
import { Scanner } from "@yudiel/react-qr-scanner";
import SimpleModal from "../../../../../../modules/popup/SimpleModal";
import Api from "../../../../../../Services/Api";
import * as R from "ramda";
import { defaultTableChange } from "../../../../../../modules/custom/customTable";

class MutasiDetailQrTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pagination: {
        page: 1,
        limit: 5,
        totalData: 0,
      },
      scannerVisible: false,
    };
    this.tableColumns = [
      {
        name: "",
        label: "No",
        options: {
          customBodyRender: (value, tableMeta) => {
              return <>{tableMeta.rowIndex + 1}</>;
          },
          sort: false,
        },
      },
      {
        name: "partCode",
        label: "Kode Part",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            const row = this.props.state.data.partBarcode[rowIndex];
            return (
              <p
                style={{
                  color:
                    !this.props.mutasiKeluarTab && row.status === "REJECTED"
                      ? "red"
                      : "inherit",
                }}
              >
                {typeof val === "object"
                  ? val?.value || val?.label || "-"
                  : val || "-"}
              </p>
            );
          },
        },
      },
      {
        name: "partName",
        label: "Nama Part",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            const row = this.props.state.data.partBarcode[rowIndex];
            return (
              <p
                style={{
                  color:
                    !this.props.mutasiKeluarTab && row.status === "REJECTED"
                      ? "red"
                      : "inherit",
                }}
              >
                {val || "-"}
              </p>
            );
          },
        },
      },
      {
        name: "partCategoryName",
        label: "Kategori",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            const row = this.props.state.data.partBarcode[rowIndex];
            return (
              <p
                style={{
                  color:
                    !this.props.mutasiKeluarTab && row.status === "REJECTED"
                      ? "red"
                      : "inherit",
                }}
              >
                {val || "-"}
              </p>
            );
          },
        },
      },
      {
        name: "qty",
        label: "Quantity",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            const row = this.props.state.data.partBarcode[rowIndex];
            return (
              <p
                style={{
                  color:
                    !this.props.mutasiKeluarTab && row.status === "REJECTED"
                      ? "red"
                      : "inherit",
                }}
              >
                {val ?? "-"}
              </p>
            );
          },
        },
      },
      {
        name: "satuan",
        label: "Satuan",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            const row = this.props.state.data.partBarcode[rowIndex];
            return (
              <p
                style={{
                  color:
                    !this.props.mutasiKeluarTab && row.status === "REJECTED"
                      ? "red"
                      : "inherit",
                }}
              >
                {val ?? "-"}
              </p>
            );
          },
        },
      },
      {
        name: "qRCode",
        label: "QR Code",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            const row = this.props.state.data.partBarcode[rowIndex];
            return (
              <p
                style={{
                  color:
                    !this.props.mutasiKeluarTab && row.status === "REJECTED"
                      ? "red"
                      : "inherit",
                }}
              >
                {val ?? "-"}
              </p>
            );
          },
        },
      },
    ];

    if (this.props.mutasiKeluarTab) {
      if (this.props.buttonType !== "delete") {
        this.tableColumns.push({
          name: "saved",
          label: "Aksi",
          options: {
            customBodyRender: (val, { rowIndex }) => {
              return this.addDetailButton(val, rowIndex);
            },
            setCellProps: () => ({
              style: { width: "5%" },
            }),
          },
        });
      }
    } else {
      this.tableColumns.splice(5, 0, {
        name: "receivedqty",
        label: "Quantity Terima",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            const row = this.props.state.data.partBarcode[rowIndex];
            return (
              <p
                style={{ color: row.status === "REJECTED" ? "red" : "inherit" }}
              >
                {val === null || val === undefined || val === "" ? "-" : val}
              </p>
            );
          },
          setCellProps: () => ({ style: { width: "100px" } }),
        },
      });

      this.tableColumns.push({
        name: "saved",
        label: "Aksi",
        options: {
          customBodyRender: (_, { rowIndex }) => {
            return this.addDetailButton(_, rowIndex);
          },
          setCellProps: () => ({ style: { width: "5%" } }),
        },
      });
    }
  }

  handleToggleScanned = (index, checked) => {
    this.props.onSetState((prev) => {
      const updatedPartBarcode = prev.data.partBarcode.map((row, idx) =>
        idx === index ? { ...row, scanned: checked } : row,
      );

      return {
        ...prev,
        data: {
          ...prev.data,
          partBarcode: updatedPartBarcode,
        },
      };
    });
  };

  handleDeleteRow = (index) => {
    this.props.onSetState((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        partBarcode: prev.data.partBarcode.filter((_, idx) => idx !== index),
      },
    }));
  };

  handleReject = (index) => {
    this.props.onSetState((prev) => {
      const updatedPartBarcode = prev.data.partBarcode.map((row, idx) => {
        if (idx === index) {
          return {
            ...row,
            status: row.status === "REJECTED" ? "RECEIVED" : "REJECTED",
          };
        }
        return row;
      });

      return {
        ...prev,
        data: {
          ...prev.data,
          partBarcode: updatedPartBarcode,
        },
      };
    });
  };

  handleShowScanner = () => {
    this.setState((prev) => ({
      ...prev,
      scannerVisible: !prev.scannerVisible,
    }));
  };

  handleScanQR = async (scannedData) => {
    if (!scannedData || scannedData.length === 0) return;

    const barcodeValue = scannedData[0].rawValue;

    const request = {
      nameCategory: "PART",
      barcode: null,
      encryptBarcode: barcodeValue,
      kodeCabang: this.props.state.data.mutationSourceKodeCabang.value,
      kodeLocator: this.props.state.data.mutationSourceKodeLocator.value,
      trxType: this.props.mutasiKeluarTab ? "TRX_IN" : "TRX_OUT",
      codeItem: null,
    };

    const response = await Api.create(
      "NAGAMAS_TRANSACTION",
    ).findBarcodePartMutation(request);

    if (response.ok && !R.isEmpty(response.data.data)) {
      const data = response.data.data;
      console.log("DATA DARI API:", data);
      const scannedCode = data?.barcode || data?.qRCode || barcodeValue;

      const exists = this.props.state.data.partBarcode?.some(
        (item) => item.qRCode === scannedCode,
      );

      if (this.props.mutasiKeluarTab && exists) {
        alert("QR Code ini sudah di-scan sebelumnya!");
        this.handleShowScanner();
        return;
      }
      if (this.props.mutasiKeluarTab) {
        const partBarcode = Array.isArray(this.props.state.partBarcodeOptions)
          ? this.props.state.partBarcodeOptions
          : this.props.state.partBarcodeOptions
            ? [this.props.state.partBarcodeOptions]
            : [];

        console.log(data);

        if (!data?.kodeItem) {
          alert("QR Code tidak ditemukan atau data kosong!");
          this.handleShowScanner();
          return;
        }

        const matchedPart =
          partBarcode.find((p) => p?.value === data?.kodeItem) || null;

        if (
          this.props.state.data.mutationSourceKodeLocator.value ===
          data.kodeLocator
        ) {
          const newPart = {
            id: null,
            mutationPartId: null,
            mutationId: this.props.state.data?.mutationId,
            partCode: { value: data?.kodeItem, label: data.kodeItem },
            partName: matchedPart?.name || data?.nameItem || "-",
            partCategoryName:
              matchedPart?.category || data?.categoryItem || "-",
            qty: 1,
            satuan: matchedPart?.satuan || data?.satuan || "-",
            qRCode: scannedCode,
            scanned: false,
            status: "ONPROGRESS",
          };

          this.props.onSetState((prev) => ({
            ...prev,
            data: {
              ...prev.data,
              partBarcode: [...prev.data?.partBarcode, newPart],
            },
          }));
        }
      } else {
        this.props.onSetState((prev) => {
          const updated = prev.data?.partBarcode.map((item) => {
            const isSame =
              item.partCode?.value === data?.kodeItem &&
              item.qRCode === scannedCode;

            if (isSame) return { ...item, scanned: true };
            return item;
          });

          const anyMatched = updated.some((item) => item.scanned);
          if (!anyMatched) {
            alert("QR Code tidak cocok dengan data part di tabel!");
          }

          return {
            ...prev,
            data: {
              ...prev.data,
              partBarcode: updated,
            },
          };
        });
      }

      this.handleShowScanner();
    } else {
      this.setState({ scannerVisible: false });
      alert("QR Code tidak ditemukan atau data kosong!");
    }
  };

  addDetailButton = (val, rowIndex) => {
    const row = this.props.state.data.partBarcode[rowIndex];
    const isRejected = row.status === "REJECTED";
    const isDisabled = this.props.buttonType === "preview";
    const isScanned = row.scanned === true;

    return (
      <FlexView vAlignContent="center">
        {/* {this.props.mutasiKeluarTab && (
          <Button
            className="btnAct"
            onClick={() =>
              !isRejected && !isDisabled && this.handleSaveRow(rowIndex)
            }
            disabled={isRejected || isDisabled}
          >
            <span
              style={{
                backgroundColor: "transparent",
                color: isRejected || isDisabled ? "gray" : "red",
                fontSize: 20,
              }}
            >
              {!row.saved ? (
                <i className="fa fa-save" />
              ) : (
                <i className="fa fa-pencil-alt" />
              )}
            </span>
          </Button>
        )} */}

        {this.props.mutasiKeluarTab ? (
          <Button
            className="btnAct margin-left-15px"
            // onClick={() =>
            //   !isRejected && !isDisabled && this.handleDeleteRow(rowIndex)
            // }
            // disabled={isRejected || isDisabled}
            onClick={() => !isDisabled && this.handleDeleteRow(rowIndex)}
            disabled={isDisabled}
          >
            <i
              className="fa fa-trash"
              style={{
                backgroundColor: "transparent",
                // color: isRejected || isDisabled ? "gray" : "red",
                color: isDisabled ? "gray" : "red",
                fontSize: 20,
              }}
            />
          </Button>
        ) : (
          <div style={{ display: "flex", alignItems: "center", gap: "0px" }}>
            <input
              type="checkbox"
              checked={isScanned}
              readOnly
              style={{ width: 18, height: 18 }}
            />
            <Button
              className="btnAct margin-left-15px"
              onClick={() => !isDisabled && this.handleReject(rowIndex)}
              disabled={isDisabled}
            >
              <span
                style={{
                  position: "relative",
                  fontSize: 20,
                  display: "inline-block",
                }}
              >
                <i
                  className="fas fa-hand-paper"
                  style={{
                    color: isRejected || isDisabled ? "gray" : "red",
                  }}
                />
                <i
                  className="fas fa-slash"
                  style={{
                    position: "absolute",
                    top: 2.5,
                    left: 0,
                    color: isRejected || isDisabled ? "gray" : "red",
                  }}
                />
              </span>
            </Button>
          </div>
        )}
      </FlexView>
    );
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  render() {
    const { pagination } = this.state;
    return (
      <>
        <FlexView
          vAlignContent="center"
          className="margin-bottom-10px"
          style={{ gap: "10px" }}
        >
          <Button
            type="button"
            className="btn"
            disabled={
              this.props.buttonType == "preview" ||
              this.props.buttonType == "delete"
            }
            style={{ borderRadius: "50%" }}
            onClick={this.handleShowScanner}
          >
            <i className="fa fa-qrcode"></i>
          </Button>
        </FlexView>

        <SimpleDataTable
          key={`${pagination.totalData}-${pagination.page}`}
          data={this.props.state.data.partBarcode}
          columns={this.tableColumns}
          rowsPerPage={pagination.limit}
          page={pagination.page - 1}
          toCount={this.props.state.data.partBarcode?.length || 0}
          options={{
            ...defaultTableChange(
              this.handleChangePage,
              this.handleRowsPerPage,
            ),
            serverSide: false,
            fixedHeader: true,
            tableBodyHeight: "400px",
            setRowProps: () => ({ style: { height: "auto", minHeight: 48 } }),
          }}
        />

        {this.state.scannerVisible && (
          <SimpleModal
            title="Scan QR Here"
            styles={{ width: "40%" }}
            visible={this.state.scannerVisible}
            onClickClose={this.handleShowScanner}
            content={
              <Scanner
                onScan={this.handleScanQR}
                constraints={{
                  height: { ideal: 720 },
                  video: {
                    facingMode: { exact: "environment" },
                    height: { ideal: 720 },
                  },
                }}
              />
            }
          />
        )}
      </>
    );
  }
}

export default MutasiDetailQrTab;
